import React, { useEffect, useRef } from "react";
import { Icon } from "../components/Icon";
import styles from "./Query.module.css";

export type QueryProps = {
  onChange: (value: string) => void;
  placeholder: string;
  value: string;
};

export const QueryComponent = ({
  onChange,
  placeholder,
  value,
}: QueryProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const _onChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(e.target.value);
    },
    [onChange]
  );

  const clear = React.useCallback(() => {
    onChange("");
    inputRef?.current?.focus();
  }, [onChange, inputRef.current]);

  useEffect(() => {
    function onKeyUp(e: KeyboardEvent) {
      if (e.key === "Escape") clear();
    }
    window.addEventListener("keyup", onKeyUp);
    return () => window.removeEventListener("keyup", onKeyUp);
  }, [inputRef.current]);

  return (
    <div className={styles.container}>
      <span className={styles.iconWrapper}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="none">
          <path d="M19.734 17.867c1.333-1.734 2.266-4 2.266-6.534C22 5.467 17.2.667 11.334.667 5.467.667.667 5.467.667 11.333.667 17.2 5.467 22 11.334 22c2.4 0 4.666-.8 6.533-2.267l7.6 7.6 1.867-1.866-7.6-7.6zm-8.4 1.466c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8A8.083 8.083 0 0117.867 16c-.533.667-1.2 1.333-1.867 1.867a8.082 8.082 0 01-4.666 1.466z"></path>
        </svg>
      </span>
      <input
        ref={inputRef}
        className={styles.searchField}
        value={value}
        type="text"
        id="search"
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="none"
        spellCheck="false"
        onChange={_onChange}
        placeholder={placeholder}
      />
      {Boolean(value.length) && (
        <button type="button" className={styles.clearButton} onClick={clear}>
          <Icon icon="clear" />
        </button>
      )}
    </div>
  );
};

export const Query = React.memo(QueryComponent);
